import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogData';
import SEO from '../components/seo/SEO';
import Breadcrumbs from '../components/navigation/Breadcrumbs';

const BlogPost = () => {
    const { slug } = useParams();
    const post = BLOG_POSTS.find(p => p.slug === slug);

    if (!post) {
        return (
            <div className="container py-5 text-center">
                <h2>Post not found</h2>
                <Link to="/blog" className="btn btn-primary mt-3">Back to Blog</Link>
            </div>
        );
    }

    return (
        <div className="container py-5">
            <SEO
                title={`${post.title} | ToyTrade Blog`}
                description={post.excerpt}
                canonical={`https://toytrade.pk/blog/${post.slug}`}
                image={post.image}
                type="article"
            />

            <Breadcrumbs
                items={[
                    { label: 'Blog', link: '/blog' },
                    { label: post.title }
                ]}
            />

            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <article className="text-start">
                        <h1 className="display-4 fw-bold mb-3">{post.title}</h1>
                        <div className="d-flex align-items-center mb-4 text-muted">
                            <span className="me-3">By {post.author}</span>
                            <span>|</span>
                            <span className="ms-3">{post.date}</span>
                        </div>

                        <img
                            src={post.image}
                            className="img-fluid rounded-4 mb-5 shadow-sm w-100"
                            alt={post.title}
                            onError={(e) => { e.target.src = '/images/blog/blog_placeholder.jpg' }}
                        />

                        <div
                            className="blog-content fs-5 lh-lg"
                            dangerouslySetInnerHTML={{ __html: post.content }}
                        />

                        <div className="mt-5 pt-4 border-top">
                            <h5 className="fw-bold mb-3">Tags:</h5>
                            <div className="d-flex flex-wrap gap-2">
                                {post.tags.map(tag => (
                                    <span key={tag} className="badge bg-light text-primary border px-3 py-2">
                                        #{tag}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="mt-5 text-center">
                            <Link to="/blog" className="btn btn-primary btn-lg">Back to All Posts</Link>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    );
};

export default BlogPost;
